import { render, staticRenderFns } from "./Layers.vue?vue&type=template&id=675c41e3&scoped=true"
import script from "./Layers.vue?vue&type=script&lang=ts&setup=true"
export * from "./Layers.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Layers.vue?vue&type=style&index=0&id=675c41e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c41e3",
  null
  
)

export default component.exports